export const TEMPLATE_FIELD_LABELS = {
  // Entity Type
  entityCountry: 'intake_form.entity_type.country_of_incorporation',
  entityTypeCategoryId: 'intake_form.entity_type.entity_type',

  // Basic Info
  referrerName: 'intake_form.basic_info.referrerName',
  referrerCompany: 'intake_form.basic_info.referrerCompany',
  hearTenet: 'intake_form.basic_info.hearTenet',
  entityDBA: 'intake_form.basic_info.trade_name',
  referrerMore: 'intake_form.basic_info.referrerInformation',
  entityLegalName: 'intake_form.basic_info.legal_name',
  relationshipTemplateId: 'intake_form.basic_info.relationship_template',

  // Entity Profile
  city: 'intake_form.entity_profile.city',
  type: 'intake_form.entity_profile.type_of_address',
  state: 'intake_form.entity_profile.state',
  street: 'intake_form.entity_profile.street',
  country: 'intake_form.entity_profile.country',
  postalCode: 'intake_form.entity_profile.postal',
  numOffices: 'intake_form.entity_profile.number_of_offices',
  isOperatingInSanctionedCountries:
    'intake_form.entity_profile.is_operating_in_sanctioned_countries',
  isRegulated: 'intake_form.entity_profile.is_regulated',
  addressLabel: 'intake_form.field_labels.addressLabel',
  numEmployees: 'intake_form.entity_profile.number_of_employees',
  entityWebsite: 'intake_form.entity_profile.company_website',
  hasBearerShares: 'intake_form.entity_profile.has_bearer_shares',
  regulationCountry: 'intake_form.entity_profile.in_which_country',
  registrationNumber: 'intake_form.entity_profile.registration_number',
  entityDateFormation: 'intake_form.entity_profile.date_of_incorporation',
  regulationExemption: 'intake_form.entity_profile.exemption_from_regulation',
  entityOperationStart: 'intake_form.entity_profile.entityAge',

  // Customers & Products
  industryCodes: 'intake_form.customers_and_products.industry_codes',
  subIndustries: 'intake_form.customers_and_products.sub_industry',
  isBlockchainTechnologyUsed:
    'intake_form.customers_and_products.project_technology',
  isVirtualAssetsInvolvedInBusiness:
    'intake_form.customers_and_products.use_blockchain_technology',
  involvedVirtualAssets:
    'intake_form.customers_and_products.virtual_asset_options',
  customerGroups: 'intake_form.customers_and_products.customers',
  customerGroupOtherDetails:
    'intake_form.customers_and_products.customers_other',
  sourcesOfRevenue: 'intake_form.customers_and_products.source_of_revenue',
  sourceOfRevenueOtherDetails:
    'intake_form.customers_and_products.source_of_revenue_other',
  projectedRevenue6m:
    'intake_form.customers_and_products.revenue_in_six_months',
  projectedRevenue12m: 'intake_form.customers_and_products.revenue_in_one_year',
  projectedRevenue24m:
    'intake_form.customers_and_products.revenue_in_two_years',
  businessDescription: 'intake_form.customers_and_products.business_info',
  supportingDocuments:
    'intake_form.customers_and_products.supporting_documents',
  projectedRevenue6mAmount:
    'intake_form.customers_and_products.amount_of_revenue',
  projectedRevenue12mAmount:
    'intake_form.customers_and_products.amount_of_revenue',
  projectedRevenue24mAmount:
    'intake_form.customers_and_products.amount_of_revenue',

  // Funding
  otherBanks: 'intake_form.funding.other_bank_accounts_info',
  sourceOfFunds: 'intake_form.funding.source_of_initial_deposit',
  sourceOfFundsOtherDetails:
    'intake_form.funding.source_of_initial_deposit_other_details',
  hasOtherBanks: 'intake_form.funding.hold_account_anywhere_else',
  initialDeposit: 'intake_form.funding.initial_deposit',
  counterpartyType: 'intake_form.funding.counterparty_name',
  thirdPartyName: 'intake_form.funding.third_party_name',
  thirdPartyRelationship: 'intake_form.funding.third_party_relationship',
  isPrimaryAccount: 'intake_form.funding.is_primary_bank_account',
  otherBankFeedback: 'intake_form.funding.issues_with_other_banks',
  initialDepositAmount: 'intake_form.funding.specify_amount',
  accountUsePercentage: 'intake_form.funding.account_use_percentage',
  initialDepositCountries: 'intake_form.funding.country_of_initial_deposit',
  intendToTransferFundsFrame:
    'intake_form.funding.timeframe_of_initial_deposit',
  plansToOpenExternalBankAccounts:
    'intake_form.funding.plans_to_open_external_accounts',
  plansToOpenExternalBankAccountsDetails:
    'intake_form.funding.plans_to_open_external_accounts_details',
  intendToTransferFundsFrameDetails:
    'intake_form.funding.more_info_about_initial_deposit',

  // Account
  fullName: 'intake_form.associated_individuals.full_name',
  purposeOfAccount: 'intake_form.account.purpose',
  accountCountries: 'intake_form.account.transaction_countries',
  avarageMonthlyBalance: 'intake_form.account.average_monthly_balance',
  hasOtherBeneficialOwners:
    'intake_form.associated_individuals.are_individuals',
  incomingTransactionNumber:
    'intake_form.account.number_of_incoming_transactions',
  incomingTransactionVolume:
    'intake_form.account.value_of_incoming_transactions',
  outgoingTransactionNumber:
    'intake_form.account.number_of_outgoing_transactions',
  outgoingTransactionVolume:
    'intake_form.account.value_of_outgoing_transactions',
  accountInflowsDetails: 'intake_form.account.account_inflows_details',
  accountOutflowsDetails: 'intake_form.account.account_outflows_details',

  // Associated Individuals
  beneficialOwnerLabel: 'intake_form.field_labels.beneficialOwnerLabel',
  countryOfResidence: 'intake_form.associated_individuals.country',
  relationshipToEntity: 'intake_form.associated_individuals.relationship',

  // Service Providers
  serviceProviderId: 'intake_form.service_providers.service_provider',
};
